export default {
    not_found: 'a1.x61',
    generic: 'a1.x67',
}